import clsx from 'clsx';
import { useEffect, useState } from 'react';
import PanelButton from './panel-button';

interface ContinueButtonProps {
  loading?: boolean;
  onClick: () => void;
  recenter?: boolean;
  text?: string;
}

/**
 * A simple "Continue" button, typically rendered under a form's fields.
 */
function ContinueButton({
  onClick,
  text = 'Continue',
  loading,
  recenter = false,
}: ContinueButtonProps) {
  const [loadingWithDelay, setLoadingWithDelay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoadingWithDelay(loading), 400);
    return () => clearTimeout(timer);
  }, [loading]);

  return (
    <div className={clsx('mt-6', recenter && 'md:flex')}>
      <PanelButton isContinueButton loading={loadingWithDelay} onClick={onClick} text={text} />
    </div>
  );
}

export default ContinueButton;
